"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _Dialog = require("../Dialog/Dialog");
var _Mask = require("../Mask/Mask");
var _Modal = require("./Modal.styles");
var _excluded = ["backdrop", "className", "dialog", "globalStyle", "isOpen", "portal"];
/**
 * The `Modal` component provides the base for modal dialogs such as
 * `ModalDialog` and `Popover`.
 *
 * Non-documented props will be passed to the dialog node.
 *
 * @related ['Dialog', 'Mask', 'Popover']
 * @since 7.0.0
 */
var Modal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var backdrop = _ref.backdrop,
    className = _ref.className,
    dialog = _ref.dialog,
    globalStyle = _ref.globalStyle,
    isOpen = _ref.isOpen,
    portal = _ref.portal,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Do not render anything while closed
  if (!isOpen) {
    return null;
  }

  // Pass same dialog props to global style node
  var globalStyleContent = /*#__PURE__*/(0, _react.cloneElement)(globalStyle, Object.assign({}, rest, {
    children: undefined
  }));

  // Don't portal dialog since we are handling portal at the modal level
  var dialogContent = /*#__PURE__*/(0, _react.cloneElement)(dialog, Object.assign({
    portal: false
  }, rest));
  var content = /*#__PURE__*/_react.default.createElement(_Modal.StyledModal, {
    className: className,
    ref: forwardedRef
  }, globalStyleContent, backdrop, dialogContent);
  if (portal === true && typeof document !== 'undefined') {
    return /*#__PURE__*/(0, _reactDom.createPortal)(content, document.body);
  }
  if (portal !== true && portal) {
    return /*#__PURE__*/(0, _reactDom.createPortal)(content, portal);
  }
  return content;
});
exports.Modal = Modal;
Modal.displayName = 'Modal';
Modal.propTypes = {
  /**
   * The backdrop node is a sibling of the `dialog` node used to conceal the content behind the
   * dialog.
   */
  backdrop: _propTypes.default.node,
  /**
   * The class to be passed to the modal.
   */
  className: _propTypes.default.string,
  /**
   * The Dialog component.
   */
  dialog: _propTypes.default.node,
  /**
   * The styled-components
   * [global style](https://www.styled-components.com/docs/api#createglobalstyle) node.
   */
  globalStyle: _propTypes.default.node,
  /**
   * The open state of the modal.
   */
  isOpen: _propTypes.default.bool,
  /**
   * By default, content will be rendered into a [Portal](https://reactjs.org/docs/portals.html)
   * in the document body. With this prop, you can specify a different container,
   * or you can disable the portal to render the content inline by passing `false`.
   */
  portal: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool]),
  /**
   * By default, modals should close with the ESC key.
   * This sets the prop on the Dialog component.
   */
  shouldCloseOnESCKeyPress: _propTypes.default.bool,
  /**
   * By default, modals should close when clicking outside the dialog content.
   * This sets the prop on the Dialog component.
   */
  shouldCloseOnOutsideClick: _propTypes.default.bool
};
Modal.defaultProps = {
  dialog: /*#__PURE__*/_react.default.createElement(_Dialog.Dialog, null),
  backdrop: /*#__PURE__*/_react.default.createElement(_Mask.Mask, null),
  className: undefined,
  globalStyle: /*#__PURE__*/_react.default.createElement(_Modal.ModalGlobalStyle, null),
  isOpen: undefined,
  portal: true,
  shouldCloseOnESCKeyPress: true,
  shouldCloseOnOutsideClick: true
};